import { IAnnouncerPack } from "./IAnnouncerPack";
import { AnnouncerPackFactory } from "./AnnouncerPackFactory";

/**
 * Registry that routes events to appropriate announcer pack based on category
 * Maps event types to categories (frag, lines, taunt, etc.)
 */
export class AnnouncerPackRegistry {
  private factory: AnnouncerPackFactory;
  private eventCategoryMap: Map<string, string> = new Map([
    ["frag", "frag"],
    ["firstBlood", "frag"],
    ["multiKill", "frag"],
    ["killStreak", "frag"],
    // Future: ["lines", "lines"], ["taunt", "taunt"], etc.
  ]);

  constructor(factory: AnnouncerPackFactory) {
    this.factory = factory;
  }

  /**
   * Gets the appropriate pack for an event type based on its category
   */
  getPackForEventType(eventType: string): IAnnouncerPack {
    const category = this.eventCategoryMap.get(eventType);
    
    if (category === "frag") {
      return this.factory.getFragAnnouncerPackFromStorage();
    }
    
    // Future: handle "lines", "taunt" categories
    
    // Fallback to default pack for unmapped events
    return this.factory.getFragAnnouncerPack("default");
  }
}

